import { StateCreator } from 'zustand';
import type { ViewSlice, CombinedStore, Views } from './types';

export const createViewSlice: StateCreator<CombinedStore, [], [], ViewSlice> = (
	set
) => ({
	activeView: 'pricing-rules',
	setActiveView: (view: Views) => set({ activeView: view }),
});
